import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Path, routeDetails } from '../../../../../router/routeDetails';
import { EnrichedStopPlace } from '../../../../../types';
import { showSuccessToast } from '../../../../../utils';
import {
  SimpleDropdownMenu,
  SimpleDropdownMenuItem,
} from '../../../../common/Dropdowns';
import { ShowOnMap } from '../../../Search/Components/StopPlaceSharedComponents/ActionMenu/ShowOnMap';
import {
  DeleteStopArea,
  useStopAreaDeletion,
  useUpsertStopArea,
} from '../../Common';
import { CopyStopAreaModal } from '../../Versions/CopyStopArea';

const testIds = {
  actionMenu: 'StopAreaTitleRow::actionMenu',
  copy: 'StopAreaTitleRow::copy',
  delete: 'StopAreaTitleRow::delete',
  showOnMap: 'StopAreaTitleRow::showOnMap',
};

type TitleRowActionsProps = {
  readonly className?: string;
  readonly area: EnrichedStopPlace;
  readonly showOnMap: () => void;
};

export const TitleRowActions: FC<TitleRowActionsProps> = ({
  className,
  area,
  showOnMap,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { isConfirmDeleteDialogOpen, openDeleteDialog, closeDeleteDialog } =
    useStopAreaDeletion();
  const { defaultErrorHandler } = useUpsertStopArea();

  const [isCopyDialogOpen, setIsCopyDialogOpen] = useState(false);

  const onDeleteSuccess = () => {
    showSuccessToast(t(($) => $.stopArea.deleteSuccess));
    navigate(routeDetails[Path.stopRegistry].getLink());
  };

  return (
    <>
      <SimpleDropdownMenu
        className={className}
        buttonClassName="h-11 w-11"
        buttonShape="round"
        tooltip={t(($) => $.accessibility.common.actionMenu)}
        testId={testIds.actionMenu}
        disabled={!area}
      >
        <SimpleDropdownMenuItem
          text={t(($) => $.stopArea.copy)}
          onClick={() => setIsCopyDialogOpen(true)}
          testId={testIds.copy}
        />
        <SimpleDropdownMenuItem
          text={t(($) => $.stopArea.delete)}
          onClick={openDeleteDialog}
          testId={testIds.delete}
        />
        <ShowOnMap
          key="showOnMap"
          onClick={showOnMap}
          testId={testIds.showOnMap}
          text={t(($) => $.stopRegistrySearch.stopAreaRowActions.showOnMap)}
        />
      </SimpleDropdownMenu>
      <CopyStopAreaModal
        stopArea={area}
        isOpen={isCopyDialogOpen}
        onClose={() => setIsCopyDialogOpen(false)}
      />
      <DeleteStopArea
        stopArea={area}
        isOpen={isConfirmDeleteDialogOpen}
        onClose={closeDeleteDialog}
        onDeleteSuccess={onDeleteSuccess}
        defaultErrorHandler={defaultErrorHandler}
      />
    </>
  );
};
